"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Esignature = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M1 18a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z", opacity: 0.4 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M6.744 3.753c-.398-.062-.845.004-1.35.277-1.087.585-1.681 1.416-1.931 2.355-.255.959-.162 2.082.239 3.226.466 1.33 1.32 2.607 2.39 3.588a8.106 8.106 0 0 1 4.53-2.68 15.908 15.908 0 0 0-.511-2.329c-.519-1.713-1.278-3.056-2.128-3.803-.417-.367-.833-.571-1.239-.634Zm5.371 6.613a17.44 17.44 0 0 0-.568-2.61c-.56-1.848-1.43-3.49-2.573-4.496-.58-.51-1.25-.873-2-.99-.757-.116-1.532.03-2.293.44-1.446.78-2.31 1.947-2.668 3.289-.351 1.321-.2 2.76.273 4.108.56 1.594 1.598 3.144 2.93 4.323-.14.239-.272.489-.395.751-.643 1.369-.924 2.778-.912 4.022.012 1.225.31 2.373.922 3.148.313.396.724.711 1.23.853.51.144 1.049.091 1.575-.13 1.015-.428 2.028-1.497 3.013-3.198 1.328-2.295 1.78-5.222 1.616-8.007.047.001.093.004.14.006.647.04 1.124.201 1.397.388.26.177.347.335.389.46.051.156.057.333.051.616 0 .02 0 .041-.002.064-.006.235-.017.615.102.96.162.47.516.805 1.042.995.71.257 1.292-.1 1.652-.434.354-.33.671-.797.934-1.184l.027-.04c.276-.406.51-.752.751-1.008a1.29 1.29 0 0 1 .316-.263c.008.025.018.054.028.09.042.146.075.327.11.552l.02.124c.028.182.06.387.1.576.049.233.12.507.248.752.13.252.355.54.735.68.377.14.76.078 1.095-.054.333-.131.687-.358 1.068-.663a.75.75 0 1 0-.936-1.172c-.313.25-.529.376-.666.433a2.197 2.197 0 0 1-.075-.282c-.032-.15-.056-.306-.084-.484l-.023-.147a6.369 6.369 0 0 0-.15-.726c-.066-.233-.174-.523-.38-.763a1.266 1.266 0 0 0-.981-.451c-.672 0-1.178.41-1.517.77-.326.347-.624.786-.875 1.156l-.052.078c-.287.423-.51.736-.715.928a.715.715 0 0 1-.146.111.353.353 0 0 1-.105-.056.073.073 0 0 1-.002-.006c-.024-.067-.027-.17-.02-.503.007-.275.016-.69-.126-1.12-.152-.459-.454-.878-.967-1.228-.568-.388-1.336-.596-2.152-.646a6.523 6.523 0 0 0-.38-.012Zm8.638 3.416h.002Zm-9.981-1.76a6.597 6.597 0 0 0-3.485 2.09c.46.285.945.515 1.442.674a.75.75 0 0 1-.458 1.428 8.04 8.04 0 0 1-1.847-.873 7.77 7.77 0 0 0-.245.478c-.549 1.167-.78 2.354-.77 3.37.01 1.035.267 1.812.599 2.232.158.2.317.3.459.34.137.038.325.04.587-.07.56-.236 1.365-.957 2.297-2.567 1.142-1.973 1.56-4.577 1.42-7.102Z"
      }
    )
  );
};
export default Esignature;
